export const getShouldShowCitySelector = (path) => {
    // set showCitySelector to false by default and route him to "online"
    return path === "/";
};
